module.exports = __webpack_public_path__ + "static/media/data-details.099b67b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/data-details.png
// module id = 1819
// module chunks = 0